import { format } from "date-fns";

import { Form } from "semantic-ui-react";

import React from "react";

import DateTime from "./DateTime";

export default function DateInput({ name, value, label, className, onChange, formatAs, error, disabled, ...props }) {
	return (
		<Form.Input label={label} error={error} className={className} disabled={disabled}>
			<DateTime
				value={value}
				onChange={(date) => {
					const value = date && formatAs ? format(date, formatAs) : date;

					onChange(null, { name, value: value || null });
				}}
				{...props}
			/>
		</Form.Input>
	);
}
